import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './contexts/theme';
import { UserProvider } from './contexts/user';
import './index.css';
import "./translate";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './contexts/auth';
import { SocketProvider } from './contexts/messages';
import { ModalsProvider } from './contexts/modals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        <ThemeProvider>
          <UserProvider>
            <ModalsProvider>
              <App />
            </ModalsProvider>
          </UserProvider>
        </ThemeProvider>
      </SocketProvider>
    </AuthProvider>
  </React.StrictMode>
);